import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Helmet } from "react-helmet-async";

const Home = () => {
  const [data, setData] = useState([]);
  const [informasiAkun, setInformasiAkun] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMenu = async () => {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {

        navigate('/login');
        return;
      }

      try {
        // Decode token untuk mendapatkan informasi akun
        const decoded = jwtDecode(authToken);
        setInformasiAkun(decoded);

        if (!decoded.akses) {
          navigate('/daftar/identifikasiakses');
          return;
        }

        // Fetch data menu dari server
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/getDashboardData`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch menu");
        }

        const data = await response.json();
        setData(data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMenu();
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Dashbard Griya Vidya</title>
      </Helmet>
      <div>
        <div className="pc-container">
          <div className="pc-content">
            <div className="row">
              {data?.map((item, index) =>
                item.type === "Card" ? (
                  item?.data?.map((subItem, subIndex) => (
                    <div className="col-xl-3 col-md-6" key={subIndex}>
                      <div className="card comp-card">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h5 className="m-b-20">{subItem.title}</h5>
                              <h3>{subItem.data}</h3>

                            </div>
                            {/* <div className="col-auto">
                            <i className="fas fa-eye bg-light-primary text-primary"></i>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );



};

export default Home;
